import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px 200px;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
`;

export const FirstWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const SecondWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  /* flex: 1; */
`;
export const Title = styled.div`
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  line-height: 3.5;
  color: #151515;
`;

export const Link = styled.a`
  font-family: Open Sans;
  font-size: 14px;
  color: #6a983c;
  line-height: 2;
  cursor: pointer;
  text-decoration: none;
  :active {
    transform: scale(0.99);
  }
  :hover {
    color: #6abe3c;
  }
`;
export const TagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px;
  flex-wrap: wrap;
`;
export const Tags = styled.a`
  padding: 4px 10px;
  background: #f5f5f5;
  border-radius: 12px;
  cursor: pointer;
  :active {
    transform: scaleX(0.9);
  }

  font-family: Poppins;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  margin-right: 20px;
  margin-bottom: 15px;
`;
export const Copyright = styled.div`
  font-family: Open Sans;
  font-size: 14px;
  color: #151515;
  margin-top: 20px;
`;
